import { combineReducers } from 'redux'
import { reducer as formReducer } from 'redux-form'
import entities from './modules/entities'
import hash from './modules/hash'
import list from './modules/list'
import set from './modules/set'
import { batchReducer } from './modules/lib/batchReducer'

const combinedReducer = combineReducers({
  entities,
  hash,
  list,
  set,
  form: formReducer
})

// allow batching multiple standard actions at once using batch([action, action, action...])
export default batchReducer(combinedReducer)



// WEBPACK FOOTER //
// ./src/app-reducer.js